import type { SVGProps } from 'react'
const SvgEConsent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.69336 7.8418H8.94336L10.4434 6.3418H3.69336V7.8418ZM3.69336 4.8418H8.19336V3.3418H3.69336V4.8418ZM2.19336 1.8418V9.3418H7.44336L5.94336 10.8418H0.693359V0.341797H15.6934V2.5918H14.1934V1.8418H2.19336ZM16.3684 5.8168C16.4309 5.8793 16.4621 5.94805 16.4621 6.02305C16.4621 6.09805 16.4309 6.1668 16.3684 6.2293L15.6934 6.9043L14.3809 5.5918L15.0559 4.9168C15.1184 4.8543 15.1871 4.82305 15.2621 4.82305C15.3371 4.82305 15.4059 4.8543 15.4684 4.9168L16.3684 5.8168ZM8.94336 12.3418V11.0293L13.9309 6.0418L15.2434 7.3543L10.2559 12.3418H8.94336Z"
      fill="#C8355A"
    />
  </svg>
)
export default SvgEConsent
